'use strict';

function SalaryBasisController(salaryService) {
  var vm = this;
  vm.$onInit = $onInit;
  vm.useNewPerformanceAssessment = useNewPerformanceAssessment;

  function $onInit() {
    vm.basis = vm.data || [];
    vm.getPerformanceAssessmentUrl = getPerformanceAssessmentUrl;

    vm.questionnaireUrl = salaryService.urls.questionnaire.base;
  }

  function getPerformanceAssessmentUrl(basis) {
    if (!basis.performance_assessment) {
      return '#';
    }
    return basis.performance_assessment.manager_doc_url;
  }

  function useNewPerformanceAssessment(basis) {
    if (!basis.performance_assessment) {
      return false;
    }
    return !!basis.performance_assessment.manager_doc_url;
  }
}

module.exports = SalaryBasisController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-basis/salary-basis.controller.js
 ** module id = 233
 ** module chunks = 0
 **/